class SystemProperty {

    Vue;

    get $lv() {
        return this.Vue.prototype.$lv
    }

    get $http() {
        return this.Vue.prototype.$http
    }

    get $storage() {
        return this.Vue.prototype.$storage
    }

    get $dialog() {
        return this.Vue.prototype.$dialog
    }

    get $utils() {
        return this.$lv.$utils
    }

    initialized = false;

    queryProperties = [
        {
            key: 'maxShowTabAmount',
            default: 8,
            data: null,
        },
        {
            key: 'recentlyUpdatedNum',
            default: 7,
            data: null,
        },
        {
            key: 'recentlyCreatedNum',
            default: 7,
            data: null,
        },
    ]

    constructor(Vue) {
        this.Vue = Vue
    }

    async initSystemProperty() {
        const {success, rows} = await this.$http.post(`/action/${LinkVue.prefixUrl}/cfgProperty/queryByExamplePage`, {
            filtersRaw: [{
                id: 'key',
                property: 'key',
                operator: 'in',
                value: `[${this.queryProperties.map(item => item.key).join(',')}]`
            }],
            corpid: '000'
        }, true);
        if (!success) {
            this.$dialog.show('初始化页签参数失败：' + rows);
            return
        }
        this.initialized = true
        this.queryProperties.forEach(item => item.data = this.$utils.findOne(rows, (i => i.key === item.key)))
    }

    /**
     * 获取系统参数
     * @author  韦胜健
     * @date    2019/3/29 16:57
     */
    async getProperty(key) {
        let maxTryTimes = 30
        let tryTimes = 0
        while (!this.initialized && tryTimes < maxTryTimes) {
            tryTimes++
            await this.$utils.delay(100)
        }
        const property = this.$utils.findOne(this.queryProperties, i => i.key === key)
        if (!property) {
            const msg = `找不到键值为【${key}】的系统参数`
            console.error(msg)
            return Promise.reject(msg)
        }
        return !!property.data ? property.data.value : property.default
    }
}

export {SystemProperty}
